import { render, staticRenderFns } from "./copyHuis2.vue?vue&type=template&id=81a8a5d6"
import script from "./copyHuis2.vue?vue&type=script&lang=js"
export * from "./copyHuis2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports